import React from 'react';
import { ResponsiveContainer, ComposedChart, Line, Area, XAxis, YAxis, Tooltip, CartesianGrid } from 'recharts';

import { financialChartData } from './data';
import { useStateContext } from '../../contexts/ContextProvider';
import { ChartsHeader } from '../../components';

const date1 = new Date('2017, 1, 1');

const filterValue = (value: any) => value.x >= date1;
const returnValue = financialChartData.filter(filterValue).map((d: any) => ({
  date: (d.x instanceof Date) ? d.x.toISOString().split('T')[0] : String(d.x),
  open: d.open,
  high: d.high,
  low: d.low,
  close: d.close,
  volume: d.volume,
}));

export const Financial = () => {
  const { currentMode } = useStateContext();

  return (
    <div className="m-4 md:m-10 mt-24 p-10 bg-white dark:bg-secondary-dark-bg rounded-3xl">
      <ChartsHeader category="Financeiro" title="Histórico AAPL" />
      <div className="w-full" style={{ width: '100%', height: 420, background: currentMode === 'Dark' ? '#33373E' : '#fff', padding: 8, borderRadius: 6 }}>
        <ResponsiveContainer width="100%" height="100%">
          <ComposedChart data={returnValue}>
            <CartesianGrid strokeDasharray="3 3" stroke={currentMode === 'Dark' ? '#444' : '#e6e6e6'} />
            <XAxis dataKey="date" tickFormatter={(d) => d} tick={{ fill: currentMode === 'Dark' ? '#d1d5db' : '#374151' }} />
            <YAxis tick={{ fill: currentMode === 'Dark' ? '#d1d5db' : '#374151' }} />
            <Tooltip contentStyle={{ backgroundColor: currentMode === 'Dark' ? '#1f2937' : '#fff', borderRadius: 6 }} />
            <Area type="monotone" dataKey="close" stroke="#8884d8" fill="#8884d8" />
            <Line type="monotone" dataKey="high" stroke="#82ca9d" dot={false} />
            <Line type="monotone" dataKey="low" stroke="#ff7300" dot={false} />
          </ComposedChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

